import React from 'react';
import { Button } from '@ui';
import { translate } from '@utils/i18n';
import { useToggleStatusMutation } from '../hooks/useToggleStatusMutation';
import { NAMESPACE, SUBMISSION_STATUS } from '../constants';
export default function StatusActionCell({ tdProps, dataItem }) {
    const toggleStatusMutation = useToggleStatusMutation();
    const handleToggle = () => {
        toggleStatusMutation.mutate({
            submissionId: dataItem.id
        });
    };
    const isSent = dataItem.status === SUBMISSION_STATUS.SENT;
    const buttonText = isSent
        ? translate('status.mark_complete', { namespace: NAMESPACE })
        : translate('status.mark_sent', { namespace: NAMESPACE });
    const buttonIcon = isSent ? 'fa-check' : 'fa-rotate-right';
    return (React.createElement("td", Object.assign({}, tdProps),
        React.createElement(Button, { onClick: handleToggle, disabled: toggleStatusMutation.isLoading, variant: "default" }, toggleStatusMutation.isLoading ? (React.createElement(React.Fragment, null,
            React.createElement("i", { className: "fa-light fa-spinner-third fa-spin" }),
            buttonText)) : (React.createElement(React.Fragment, null,
            React.createElement("i", { className: `fa-light ${buttonIcon}` }),
            buttonText)))));
}
